


































































import { computed, defineComponent } from '@nuxtjs/composition-api'
import HeaderSupportingData from './HeaderSupportingData.vue'
import HeaderProductSize from './HeaderProductSize.vue'
import { EMAILS, SITE_NAME } from '@/common/constants/contact'
import { MappedProduct } from '~/types/product/productTypes'
import { useCMSGlobalSettingsStore } from '~/store'

export default defineComponent({
  components: {
    HeaderSupportingData,
    HeaderProductSize,
  },
  props: {
    product: {
      type: Object as () => MappedProduct,
      required: true,
    },
  },
  setup(props) {
    const brandLogo = useCMSGlobalSettingsStore().getAttributeByCountry('headerBrandLogo').image

    const productName = computed(() => props.product.name)
    const productId = computed(() => props.product.key)
    const productUrl = computed(() => props.product.attributes.sefUrl)
    const productStorageTemperature = computed(() => props.product.attributes.productStorageTemperature!)

    return {
      EMAILS,
      SITE_NAME,
      productName,
      productId,
      productUrl,
      productStorageTemperature,
      brandLogo,
    }
  },
})
